// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1d7wv","footer":"ReportModalFilter_footer__1w_RB"};